module.exports = __webpack_public_path__ + "images/1d69ada040a9b0bc5f7523fbd1cd2f83-profile_overlay.jpg";